"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const onchainInteractionsPoolToken_1 = __importDefault(require("./onchainInteractionsPoolToken"));
class OnchainInteractionsLendingVault extends onchainInteractionsPoolToken_1.default {
    constructor(interactions, lendingVault) {
        super();
        this.getInteractions = () => this.interactions;
        this.getVaultAddress = () => this.poolToken.getVaultAddress();
        this.getAccountLendingVault = this.getAccountPoolToken;
        this.getRouterContract = () => this.interactions.getDefaultRouterContract();
        this.interactions = interactions;
        this.poolToken = lendingVault;
    }
    getAccountPoolToken() {
        return this.interactions.getAccount().getLendingVault(this.getVaultAddress());
    }
}
exports.default = OnchainInteractionsLendingVault;
